export default "__VITE_ASSET__Cc4U3QxL__"